export default __webpack_public_path__ + "static/media/ContactUsIcon.316accd8.svg";